import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { LookupDataService } from '../services/lookup-data.service';

@Pipe({
  name: 'city',
  pure: true,
})
export class CityPipe implements PipeTransform {
  constructor(private lookupData: LookupDataService) {}

  transform(value: number | string | (number | string | { city?: string | number })[] | null | undefined): Observable<string> {
    const ids = this.normalizeIds(value);
    if (!ids.length) {
      return of('City not specified');
    }
    return this.lookupData.getCities({
      selectedIds: ids,
      pageNumber: 1,
      pageSize: Math.max(ids.length, 1)
    }).pipe(
      map(result => {
        const names = ids.map(id => {
          const city = result.items.find(c => String(c.id) === String(id)) as City | undefined;
          if (!city) return null;
          return city.country ? `${city.name}, ${city.country}` : city.name;
        }).filter(Boolean) as string[];
        return names.length ? names.join(' | ') : 'City not specified';
      })
    );
  }

  private normalizeIds(value: number | string | (number | string | { city?: string | number })[] | null | undefined): string[] {
    if (value === null || value === undefined || value === '') return [];
    if (Array.isArray(value)) {
      return value
        .map(v => {
          if (v && typeof v === 'object' && 'city' in v) return String((v as any).city ?? '');
          return String(v);
        })
        .filter(Boolean);
    }
    const raw = String(value);
    if (raw.includes(',')) {
      return raw.split(',').map(s => s.trim()).filter(Boolean);
    }
    return [raw];
  }
}
